export class ListZeroEtlTargetTablesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ZeroEtlTargetTablesFilters",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<ZeroEtlTargetTablesSort>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlTargetTablesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
